import { Grid } from 'theme-ui';
import KitVariantProductCard from '~/components/Collection/Page/KitVariantProductCard';
type Props = {
  spotlights: Queries.GroupFragmentFragment['spotlights'];
  validateChildren: (type: string) => boolean;
};
const ProductList = ({ spotlights, validateChildren }: Props) => {
  if (!spotlights || !spotlights.length) return null;

  return (
    <Grid
      data-testid="product-list"
      sx={{
        py: ['0 !important'],
        mx: [0],
        overflowX: ['hidden', 'auto'],
        gap: '2rem',
        gridTemplateColumns: ['repeat( auto-fit, minmax(320px, 1fr) )'],
        gridAutoRows: '1fr;',
      }}
    >
      {spotlights.map((spotlight) => {
        if (!spotlight?.content || !validateChildren(spotlight?.content?.__typename ?? '')) return null;
        const { id, content, isFeaturedCard, ...restSpotlight } = spotlight;

        return (
          <KitVariantProductCard
            colorSelect={false}
            key={id}
            fromProductSection={true}
            renderPrice={false}
            item={content}
            isFeaturedCard={false}
            {...restSpotlight}
          />
        );
      })}
    </Grid>
  );
};

export default ProductList;
